import { Skeleton, Typography } from '@mui/material';

import { RewardTransaction } from '@jebel/constants';

import { LoadingOverlay } from 'shared/components/ui';

import { RewardTransactionListItem } from '../RewardTransactionListItem';
import { Container, TransactionHistory } from './RewardTransactionsList.styles';

interface Props {
  history: RewardTransaction[] | undefined;
  loading: boolean;
}

/**
 * Displays a list of reward transactions with a loading overlay.
 *
 * @param {Object} props
 * @param {RewardTransaction[]} props.history - Array of reward transaction objects to display.
 * @param {boolean} props.loading - Whether the transaction list is currently loading.
 */
export function RewardTransactionsList({ history = [], loading }: Props) {
  return (
    <Container>
      <LoadingOverlay
        loading={loading}
        overlay={
          <TransactionHistory>
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton key={index} variant="rectangular" height={60} />
            ))}
          </TransactionHistory>
        }
      >
        <TransactionHistory>
          {history?.map(transaction => (
            <RewardTransactionListItem key={transaction.id} transaction={transaction} />
          ))}
        </TransactionHistory>
      </LoadingOverlay>

      {!loading && history.length === 0 && (
        <Typography variant="body2" color="textSecondary" align="center">
          No transactions found
        </Typography>
      )}
    </Container>
  );
}
